import React from 'react';
import { Typography, Box, Grid, Card, CardContent, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';

const StyledCard = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(3),
  backgroundColor: '#f5f5f5',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  '&:hover': {
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
}));

const ResultCard = ({ value, label }) => {
  const theme = useTheme();
  const { ref, inView } = useInView({
    triggerOnce: true, // Anima apenas uma vez quando o card entra na visão
    threshold: 0.1, // Quando 10% do card estiver visível
  });

  // Animação para os números
  const props = useSpring({
    number: inView ? value : 0,
    from: { number: 0 },
    config: { duration: 2000 },
  });

  const ValueTypography = styled(Typography)({
    fontSize: '2rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  });

  const LabelTypography = styled(Typography)({
    fontSize: '1rem',
    color: theme.palette.text.secondary,
  });

  return (
    <Grid item xs={12} sm={6} md={4}>
      <StyledCard ref={ref}>
        <CardContent>
          <ValueTypography variant="h4" component="h2">
            <animated.div>
              {props.number.to(n => Math.floor(n))}
            </animated.div>
          </ValueTypography>
          <LabelTypography variant="body1" component="p">
            {label}
          </LabelTypography>
        </CardContent>
      </StyledCard>
    </Grid>
  );
};

const ResultsSection = () => {
  const results = [
    { value: 108, label: 'Aprovações em Vestibulares' },
    { value: 288, label: 'Medalhas e Menções Honrosas em Olimpíadas' },
    { value: 96, label: 'Notas +900 em Redação' },
    { value: 151, label: 'Aprovações em Universidades Concorridas' },
    { value: 9, label: 'Aprovações no IME' },
  ];

  return (
    <Box mb={6} mt={10} className="results-section">
      <Typography variant="h4" component="h3" gutterBottom>
        Resultados
      </Typography>
      <Typography variant="body1" component="p" gutterBottom>
        Temos orgulho dos resultados que nossos alunos alcançam. Com uma taxa de aprovação de 95% no vestibular e uma média de notas acima de 8.0, estamos comprometidos com a excelência acadêmica.
      </Typography>
      <Grid container spacing={4} mt={4}>
        {results.map(({ value, label }, index) => (
          <ResultCard key={index} value={value} label={label} />
        ))}
      </Grid>
    </Box>
  );
};

export default ResultsSection;
